import FormItem from './FormItem'
import FormItemMultiple from './FormItemMultiple'

export default class Form {
  constructor (formElem) {
    this.formElem = formElem // フォームの要素
    this.errorNum = 0 // エラー総数
    this.message = '' // エラーメッセージ

    const elements = formElem.querySelectorAll(':where(input:not([type="hidden"], [type="submit"], [type="checkbox"], [type="radio"], .input-submit), select, textarea)')
    if (elements.length === 0) return

    const multipleElements = formElem.querySelectorAll('.form-multiple')

    this.multipleItems = []

    multipleElements.forEach(element => {
      const item = new FormItemMultiple(element)

      this.multipleItems.push(item)

      item.parts.forEach(part => {
        part.addEventListener('change', (e) => {
          item.validate()
        })
      })
    })

    this.items = [] // 入力項目

    elements.forEach(element => {
      const item = new FormItem(element)
      this.items.push(item)

      item.elem.onblur = () => {
        item.validate()
        this.messageElem.innerText = ''
      }
    })
    const submitButton = this.formElem.querySelector('.input-submit') // 送信ボタン
    submitButton.setAttribute('type', 'button') // typeがsubmitの場合もbuttonに変更する
    submitButton.classList.add('w-full')
    this.submitButton = submitButton

    this.createMessageElem()
    this.messageElem = this.formElem.querySelector('.form-error-submit') // メッセージを表示する要素
    this.doSubmit()
  }

  // メッセージを表示する要素を作成
  createMessageElem () {
    const newElem = document.createElement('div')
    newElem.classList.add('form-error')
    newElem.classList.add('form-error-submit')
    this.submitButton.insertAdjacentElement('afterend', newElem)
  }

  // メッセージを表示する
  showMessage () {
    if (this.errorNum > 0) {
      this.messageElem.innerText = this.errorNum + 'ヶ所のエラーがあります。内容を修正してください。'
    } else {
      this.messageElem.innerText = ''
    }
  }

  checkErrorNum () {
    this.errorNum = 0
    this.items.forEach(item => {
      item.validate()
      this.errorNum += item.errorNum()
    })

    this.multipleItems.forEach(item => {
      item.validate()
      this.errorNum += item.errorNum()
    })
    return this.errorNum
  }

  doSubmit () {
    const submitButton = this.submitButton

    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        // e.preventDefault()

        this.checkErrorNum()

        if (this.errorNum > 0) {
          this.showMessage()
        } else {
          this.formElem.submit()
        }
      }, true)
    }
  }
}
